import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression";
import { toast } from "react-toastify";

const EditPackage = () => {
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState("");

  const [price, setPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [discount, setDiscount] = useState("");

  const [loader, setLoader] = useState(false);
  const [productNames, setProductNames] = useState([]);
  const { id } = useParams();
  const productList = useSelector((state) => state.productList);
  const { products } = productList;
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [packageproduct, setPackageProduct] = useState([]);
  const [existingPackageProduct, setExistingPackageProduct] = useState([]);
  const [packageCode, setPackageCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (packageproduct.length > 0) {
      fetchProductNames();
    }
  }, [packageproduct]);

  console.log(packageproduct, "dataaaaaaaa");

  useEffect(() => {
    // if (!initialLoaded) {
    getData();
    // }
  }, [id, products]);

  const getData = async () => {
    const { data } = await Axios.get(`/api/package/${id}`);
    setName(data.name);
    setPrice(data.price);
    setOfferPrice(data.specialPrice);
    setDiscount(data.discount);
    setPhoto(data.photo);
    setPackageCode(data.packageCode || "");
    // setPackageProduct(data.product || []);
    const selectedProducts = data.product.map((item) => {
      const productDetails = products.find((p) => p._id === item.productId);
      return {
        ...productDetails,
        productId: item.productId,
        quantity: item.quantity,
      };
    });
    setPackageProduct(selectedProducts);
    // setExistingPackageProduct(data.product || []);
    setInitialLoaded(true);
  };
  console.log(packageproduct, "product");

  const fetchProductNames = async () => {
    const missingNames = packageproduct.filter((p) => !p.name);
    if (missingNames.length === 0) {
      setProductNames(packageproduct.map((p) => p.name));
      return;
    }

    try {
      const productPromises = missingNames.map((product) =>
        Axios.get(`/api/products/${product.productId}`)
          .then((response) => response.data.name)
          .catch(() => null),
      );

      const names = await Promise.all(productPromises);
      const updatedNames = names.filter(Boolean);

      setProductNames((prev) => [...prev, ...updatedNames]);
    } catch (error) {
      console.error("Error fetching product names:", error);
    }
  };

  // Calculate the total price by summing up the offerPrice of each selected product
  const totalPrice = packageproduct.reduce((acc, product) => {
    return acc + (product.offerPrice || 0) * product.quantity;
  }, 0);

const submitHandler = async (e) => {
  e.preventDefault();

  // find broken entries
  const invalidItems = packageproduct.filter(
    (item) => !(item.productId || item._id)
  );

  if (invalidItems.length > 0) {
    console.log("Invalid package items (missing productId):", invalidItems);
    toast.error(
      "One or more products in this package are invalid (likely deleted). Please remove them before saving."
    );
    return; // block submit instead of sending bad data
  }

  setLoader(true);
  const data = {
    name,
    packageCode,
    product: packageproduct.map((item) => ({
      productId: item.productId || item._id,
      quantity: item.quantity,
    })),
    photo,
    price,
    specialPrice: offerPrice,
    discount: price - offerPrice,
  };
  try {
    const res = await Axios.put(`/api/package/${id}`, data);
    toast.success("Package updated successfully!");
    if (res.status === 201) {
      setLoader(false);
      navigate("/package/view");
        getData(); // Refresh data after update
    }
  } catch (error) {
    setLoader(false);
    toast.error("Failed to update package. Please try again.");
  }
};

  const uploadFileHandler = async (e, val) => {
    console.log("uploading");
    const file = e.target.files[0];

    // Set up image compression options
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);
      setUploading(true);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await Axios.post("/api/upload", formData, config);
      if (val === "photo") {
        setPhoto(data);
      }
      toast.success("Image uploaded successfully!");
      setUploading(false);
    } catch (error) {
      console.error(error);
      toast.error("Image upload failed!");
      setUploading(false);
    }
  };

  const [errors, setErrors] = useState({});

  return (
    <>
      <div className="row">
        <div class="col-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Update Package</h4>
              <form class="forms-sample" onSubmit={submitHandler}>
                <div class="form-group">
                  <label for="exampleInputName">Package Name</label>
                  <input
                    type="text"
                    class="form-control"
                    onChange={(e) => setName(e.target.value)}
                    placeholder="package name"
                    value={name}
                    required={true}
                  />
                </div>
                <div className="form-group">
                  <label>Package Code</label>

                  <input
                    type="text"
                    className="form-control"
                    value={packageCode}
                    onChange={(e) =>
                      setPackageCode(e.target.value.toUpperCase())
                    }
                    required
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputPriority4">Photo</label>

                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => uploadFileHandler(e, "photo")}
                    // required={true}
                  />
                </div>
                <img
                  src={
                    photo === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${photo}`
                  }
                  height="100"
                />
                {/* Products */}
                <div className="form-group">
                  <label htmlFor="exampleInputPriority4">Products</label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const product = products.find(
                        (p) => p._id === selectedId,
                      );
                      if (
                        product &&
                        !packageproduct.some((p) => p._id === selectedId)
                      ) {
                        const updatedProducts = [
                          ...packageproduct,
                          { ...product, quantity: 1 },
                        ];

                        setPackageProduct(updatedProducts);

                        const newTotal = updatedProducts.reduce(
                          (acc, product) => {
                            return (
                              acc + (product.offerPrice || 0) * product.quantity
                            );
                          },
                          0,
                        );

                        setPrice(newTotal);
                      }
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select a Product
                    </option>
                    {products?.map((data) => (
                      <option key={data._id} value={data._id}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mt-3">
                  <h6>Selected Products</h6>
                  {packageproduct.length === 0 ? (
                    <p>No products selected.</p>
                  ) : (
                    <ul className="list-group">
                      {packageproduct.map((item) => (
                        <li
                          key={item._id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <span>
                            {item.name} - <strong>Quantity:</strong>
                          </span>
                          <input
                            type="number"
                            className="form-control quantity-input"
                            value={item.quantity}
                            min="1"
                            onChange={(e) => {
                              const updatedProducts = packageproduct.map((p) =>
                                p._id === item._id
                                  ? {
                                      ...p,
                                      quantity:
                                        parseInt(e.target.value, 10) || 1,
                                    }
                                  : p,
                              );

                              setPackageProduct(updatedProducts);

                              const newTotal = updatedProducts.reduce(
                                (acc, product) => {
                                  return (
                                    acc +
                                    (product.offerPrice || 0) * product.quantity
                                  );
                                },
                                0,
                              );

                              setPrice(newTotal);
                            }}
                            style={{ width: "70px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                            onClick={() =>
                              setPackageProduct(
                                packageproduct.filter(
                                  (p) => p._id !== item._id,
                                ),
                              )
                            }
                          >
                            Remove
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div class="form-group">
                  <label for="exampleInputName">Price</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Price"
                    value={price}
                    required={true}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Special Price</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Special Price"
                    value={offerPrice}
                    onChange={(e) => setOfferPrice(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Discount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="discount"
                    value={discount}
                    required={true}
                    // onChange={(e) => setDiscount(e.target.value)}
                    disabled
                  />
                </div>
                <hr />

                {loader ? (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                ) : (
                  <div className="bottom-area">
                    <p className="mt-14"></p>
                    <button type="submit" class="btn btn-primary mr-2">
                      Submit
                    </button>
                    <Link to="/package/view">
                      <button class="btn btn-light">Cancel</button>
                    </Link>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPackage;
